import React, { useEffect, useRef } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";
import { isMaintenanceMode } from "../utils/maintenance";

import logo from "../images/logo.png";

function Navbarr() {
  const location = useLocation();
  const navRef = useRef(null);

  // Publish the navbar's real bottom edge (maintenance banner included) as
  // --nav-h so pages can offset their content by exactly that much instead
  // of guessing a fixed number.
  useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;
    const update = () => {
      document.documentElement.style.setProperty(
        "--nav-h",
        `${Math.ceil(nav.getBoundingClientRect().bottom)}px`,
      );
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(nav);
    return () => observer.disconnect();
  }, []);

  const closeNavbar = () => {
    const navBar = document.querySelector(".navbar-collapse");
    if (navBar.classList.contains("show")) {
      navBar.classList.remove("show");
    }
  };

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Navbar
      ref={navRef}
      className={`navbar navbar-expand-lg navbar-light bg-brown fixed`}
      expand="lg"
      style={{
        position: "fixed",
        top: isMaintenanceMode() ? 44 : 0,
        left: 0,
        right: 0,
        zIndex: 2000,
      }}
    >
      <Navbar.Brand href="/">
        <img src={logo} alt="Your Logo" width="100" height="auto" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbarSupportedContent" />
      <Navbar.Collapse id="navbarSupportedContent" className="ml-auto">
        <Nav className="ml-auto">
          <Nav.Item className="nav-item">
            <Link
              className={`nav-link ${isActive("/") ? "active" : ""}`}
              to="/"
              onClick={() => {
                closeNavbar();
              }}
            >
              Home
            </Link>
          </Nav.Item>
          <Nav.Item className="nav-item">
            <Link
              className={`nav-link ${isActive("/About") ? "active" : ""}`}
              to="/About"
              onClick={() => {
                closeNavbar();
              }}
            >
              About Us
            </Link>
          </Nav.Item>
          <Nav.Item className="nav-item">
            <Link
              className={`nav-link ${isActive("/Process") ? "active" : ""}`}
              to="/Process"
              onClick={() => {
                closeNavbar();
              }}
            >
              Process
            </Link>
          </Nav.Item>
          <Nav.Item className="nav-item">
            <Link
              className={`nav-link ${isActive("/Reviews") ? "active" : ""}`}
              to="/Reviews"
              onClick={() => {
                closeNavbar();
              }}
            >
              Reviews
            </Link>
          </Nav.Item>
          <Nav.Item className="nav-item">
            <Link
              className={`nav-link ${isActive("/FAQ") ? "active" : ""}`}
              to="/FAQ"
              onClick={() => {
                closeNavbar();
              }}
            >
              FAQ
            </Link>
          </Nav.Item>
          <NavDropdown
            title="Current Clients"
            id="current-clients-dropdown"
            className={
              isActive("/Calendar") || isActive("/dashboard") ? "active" : ""
            }
          >
            <NavDropdown.Item
              as={Link}
              to="/Calendar"
              onClick={() => {
                closeNavbar();
              }}
            >
              Booking Calendar
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to="/dashboard"
              onClick={() => {
                closeNavbar();
              }}
            >
              Client Portal
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to="/whats-next"
              onClick={() => {
                closeNavbar();
              }}
            >
              CPN What's Next (Video)
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item
              href="https://play.google.com/store/apps/details?id=com.cpn.mobile"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                closeNavbar();
              }}
            >
              Android App (Google Play)
            </NavDropdown.Item>
            <NavDropdown.Item
              href="https://apps.apple.com/us/app/cpn-mobile/id6751247057"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                closeNavbar();
              }}
            >
              iOS App (App Store)
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Item>
            <Link
              className="btn btn-white12 my-2 my-sm-0"
              to="/booking"
              onClick={() => {
                closeNavbar();
              }}
            >
              Contact Us
            </Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navbarr;
